<template lang="pug">
  layout()
    template(v-slot:content)
      .section: .container.content
        .card.mb-10(v-for="{id, title} in user_groups.items" :value="id" :key="id")
          .card-header: .card-header-title {{ title }}
          .card-content
            b-field.is-grouped
              //- .control: b-switch.mt-5.mr-20 Активный план
              .control: b-datepicker(icon="calendar-today" placeholder="Изучить до")
              .control.is-expanded
              .control: b-button Сохранить



</template>

<script>
import Document from '@/models/Document';
import UserGroup from '@/models/UserGroup';

export default {
  props: {
    // document: new Document(),
  },

  data: () => ({
    value: new Document(),
    user_groups: UserGroup.collection(),
    isNew: true,
  }),

  created() {
    if (this.document) {
      this.value = this.document;
      this.isNew = false;
    }
    this.user_groups.$fetch({ filter: { id: 'ne:1' } });
  },

  methods: {
    afterSave(value) {
      if (this.isNew) {
        // редирект на страницу редактирования (для нового документа)
        this.$router.replace({ name: 'docs.view.edit', params: { id: value.id } });
      }
    },
  },
};
</script>
